"use client"

import { t } from "@/languages/i18n"
import { PostWorkflowStatus } from "@/types/types"
import { CalendarOutlined } from "@ant-design/icons"
import { Select, Space, Typography } from "antd"
import React from "react"
import { PublishProps } from "../../../../lib/config/types"
import { LanguagePublish, StatusPublish, VisibilityPublish } from "./StatusPublish"

const { Text } = Typography

interface ExtendedPublishProps extends Omit<PublishProps, "status" | "setStatus"> {
  status: string
  onPreview?: () => void
  onView?: () => void
  existingLanguages?: string[]
  viOnly?: boolean
  isEditMode?: boolean
  approveLoading?: boolean
  rejectLoading?: boolean
  reviewActionLoading?: boolean
  onRequestReview?: () => void
  setStatus: (status: string) => void
  onApprove?: () => void
  onReject?: (note: string) => void
  publishDate?: string | null
  onUnpublish?: () => void
  onPublishNow?: () => void
  onSchedulePublish?: (scheduledAt: string) => void
  onStatusChange?: (status: PostWorkflowStatus) => void
  reviewNote?: string | null
  submittedAt?: string | null
  reviewedAt?: string | null
}

const Publish: React.FC<ExtendedPublishProps> = ({
  isCreateEdit,
  onView,
  setStatus,
  status,
  setLanguages,
  onPageTypeChanged,
  language,
  existingLanguages,
  viOnly = false,
}) => {
  return (
    <Space direction="vertical" className="w-full" size={10}>
      {onPageTypeChanged && (
        <Text style={{ fontSize: 13, color: "var(--admin-foreground)" }} className="flex items-center gap-2">
          <CalendarOutlined /> {t("Loại nội dung")}:
          <Select
            defaultValue={t("Nội dung")}
            onChange={value => onPageTypeChanged(value === "UI Builder")}
            className="ml-1 w-fit"
            size="small"
          >
            <Select.Option value="Nội dung">{t("Nội dung")}</Select.Option>
            <Select.Option value="UI Builder">{t("UI Builder")}</Select.Option>
          </Select>
        </Text>
      )}
      <StatusPublish setStatus={setStatus} status={status} />
      <LanguagePublish
        language={language}
        setLanguages={setLanguages}
        isCreateEdit={isCreateEdit}
        existingLanguages={existingLanguages}
        viOnly={viOnly}
      />
      <VisibilityPublish status={status} onView={onView}/>
    </Space>
  )
}

export default Publish